import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AGE_OPTIONS } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation';

import styles from './FJAgeSelector.module.less';
import commonStyles from './StepForm.module.less';

const FJAgeSelector = ({ selectedAge, onAgeChange }) => {
    return (
        <div className={commonStyles.step_form}>
            <h3 className={commonStyles.step_title}>{FJLocalStore._('select-your-age')}</h3>

            {/* Age Selection */}
            <div className={classNames(commonStyles.section, styles.age_container)}>
                <div className={styles.age_options}>
                    {AGE_OPTIONS.map(age => (
                        <div className={styles.option_card} key={age.key} onClick={() => onAgeChange(age)}>
                            <FJHoverBoardGradation
                                className={styles.hover_board_box}
                                contentClassName={styles.hover_board_content}
                                active={selectedAge?.key === age.key}
                                borderRadius={12}
                                selectBgColor='#ffffff'
                            >
                                <div className={styles.age_content}>
                                    <span className={styles.age_text}>{FJLocalStore._(age.key)}</span>
                                    <div
                                        className={classNames(styles.selected_icon, {
                                            [styles.selected]: selectedAge?.key === age.key,
                                        })}
                                    >
                                        <div className={styles.selected_icon_inner} />
                                    </div>
                                </div>
                            </FJHoverBoardGradation>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

FJAgeSelector.propTypes = {
    selectedAge: PropTypes.object,
    onAgeChange: PropTypes.func.isRequired,
};

export default FJAgeSelector;
